<template>
  <div id="app">
    <!-- <audio
      ref="prabhupadaChanting"
      :src="checkIfDevMode()"
      autoplay
      loop
      style="display: none;"
    ></audio> -->

    <v-app id="inspire">
      <v-navigation-drawer
        v-model="drawer"
        :clipped="this.windowWidth < 370 ? false : true"
        :mobile-break-point="370"
        :mini-variant.sync="mini"
        app
      >
        <v-list-item class="px-2">
          <v-list-item-avatar>
            <v-img src="data:image/svg+xml;utf8;base64,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">
            </v-img>
          </v-list-item-avatar>

          <v-list-item-title style="margin: 0 0 0 10px;">Sri Bhagavam</v-list-item-title>

          <v-btn
            icon
            @click.stop="windowWidth > 369 ? mini = !mini : drawer = !drawer"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

        </v-list-item>

        <v-divider></v-divider>

        <v-list
          dense
          v-if="items && items.length > 0"
        >

          <v-list-item
            v-for="item in items"
            :key="item && item.title ? item.title : `unknow_at_${Date.now()}`"
            link
          >

            <router-link
              v-if="item && item.componentName"
              :to="{name: item.componentName , params: { lang: language } }"
            >

              <v-tooltip
                bottom
                :disabled="toggleDisable()"
              >
                <template v-slot:activator="{ on }">
                  <v-list-item-icon v-on="on">
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>

                </template>
                <span>
                  {{ item && item.title ? translate(item.title, true) : null }}
                </span>
              </v-tooltip>

              <v-list-item-content>
                <v-list-item-title>{{ item && item.title ? translate(item.title) : null }}</v-list-item-title>
              </v-list-item-content>
            </router-link>

          </v-list-item>

        </v-list>
      </v-navigation-drawer>
      <!-- <div> -->
      <v-app-bar
        color="deep-purple accent-4"
        :clipped-left="this.windowWidth < 370 ? false : true"
        app
        dark
      >

        <v-app-bar-nav-icon id="hambuger-icon" @click="openLateralBar">
        </v-app-bar-nav-icon>

        <v-toolbar-title>{{ translate('who-is-krishna') }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon v-if="false">
          <div style="align-items: center; display: flex; flex-direction: column-reverse;">
            <v-tooltip
              bottom
              :disabled="toggleDisable()"
            >
              <template v-slot:activator="{ on }">
                <a
                  id="btn-quiz"
                  @click="showQuiz"
                  v-on="on"
                >

                  <div style="max-height: 100%;">

                    <div
                      class="row"
                      style="margin-top: -3%;"
                    >
                      <div
                        class="container"
                        style="max-width:80px"
                      >
                        <img src="data:image/svg+xml;base64,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" />
                      </div>
                    </div>

                  </div>

                </a>
              </template>
              <span id="click-to-translate__span">
                {{translate('show-quiz')}}
              </span>
            </v-tooltip>
          </div>
        </v-btn>

        <!--  -->

        <div id="volume-controls">
          <v-btn icon style="margin-right: 15px;" @click="showVolumeSlider = !showVolumeSlider">
            <v-icon dark>
              mdi-volume-high
            </v-icon>
          </v-btn>
          <v-slider
            :value="volume"
            style="position: absolute; top: 3rem; right: 5.5rem;"
            v-show="showVolumeSlider"
            hint="Volume"
            thumb-label
            @change="setVolume"
            max="100"
            min="0"
            vertical
            track-color="blue"
            color="yellow"
          ></v-slider>
        </div>

        <v-btn icon>
          <div style="align-items: center; display: flex; flex-direction: column-reverse;">
            
            <v-tooltip
              bottom
              :disabled="toggleDisable()"
            >
              <template v-slot:activator="{ on }">
                <a
                  id="btn-change-language"
                  @click="setLang"
                  v-on="on"
                >

                  <div
                    v-show="language == 'en'"
                    style="max-height: 100%;"
                  >

                    <div
                      class="row"
                      style="margin-top: -3%;"
                    >
                      <div
                        class="container"
                        style="max-width:80px"
                      >
                        <img
                          class=" img-language"
                          src="img/flag-brazil.png"
                          style="padding: 2px;"
                        />
                      </div>
                    </div>

                  </div>

                  <div
                    v-show="language == 'pt'"
                    style="max-height: 100%;"
                  >

                    <div
                      class="row"
                      style="margin-top: -3%;"
                    >
                      <div
                        class="container"
                        style="max-width:80px"
                      >
                        <img
                          class="img-language"
                          src="img/flag-usa.png"
                          style="padding: 2px;"
                        />
                      </div>
                    </div>

                  </div>

                </a>
              </template>
              <span id="click-to-translate__span">
                {{translate('click-to-translate')}}
              </span>
            </v-tooltip>
          </div>
        </v-btn>

      </v-app-bar>
      <v-content>
        <v-container fluid>
          <v-row
            align="start"
            justify="center"
          >
            <router-view @checkLanguage="checkLanguage" />
          </v-row>
        </v-container>
      </v-content>
    </v-app>

    <div id="footer">

      <div
        class="fb-like"
        data-href="http://krishna-disse.web.app"
        data-width=""
        data-layout="button"
        data-action="like"
        data-size="large"
        data-share="false"
      ></div>

      <social-sharing
        url="http://krishna-disse.web.app"
        :title="this.socialSharingTitle"
        :description="translate('site-description')"
        :quote="translate('golokera-prema-dhan')"
        hashtags="hare_krishna,god,pure_devotion"
        inline-template
        :language="this.language"
        v-show="checkRoute()"
      >
        <div id="social-media-links">

          <!-- <span> {{ translate() }} </span> -->

          <network
            network="facebook"
            style="color: blue;"
          >
            <i class="fab fa-facebook"></i>
            <!-- Facebook -->
          </network>
          <network
            network="linkedin"
            style="color: cadetblue"
          >
            <i class="fab fa-linkedin"></i>
            <!-- LinkedIn -->
          </network>
          <network
            network="pinterest"
            style="color: brown;"
          >
            <i class="fab fa-pinterest"></i>
            <!-- Pinterest -->
          </network>
          <network
            network="reddit"
            style="color: darkmagenta"
          >
            <i class="fab fa-reddit"></i>
            <!-- Reddit -->
          </network>
          <network
            network="skype"
            style="color: slategrey;"
          >
            <i class="fab fa-skype"></i>
            <!-- Skype -->
          </network>
          <network network="sms">
            <i class="far fa-comments"></i>
            <!-- SMS -->
          </network>
          <network
            network="telegram"
            style="color: skyblue;"
          >
            <i class="fab fa-telegram"></i>
            <!-- Telegram -->
          </network>
          <network
            network="twitter"
            style="color: aquamarine;"
          >
            <i class="fab fa-twitter"></i>
            <!-- Twitter -->
          </network>
          <network
            network="whatsapp"
            style="color: green;"
          >
            <i class="fab fa-whatsapp"></i>
            <!-- Whatsapp -->
          </network>
          <network network="email">
            <i class="fa fa-envelope"></i>
            <!-- Email -->
          </network>
        </div>
      </social-sharing>
    </div>
  </div>
</template>

<script>
import { eventBus } from "./main.js"
import icons from "./assets/base64icons.json"
import mixins from "./assets/mixins.js"
import airtable from "./assets/airtable.js"
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "app-first-container",
  mixins: [mixins],
  created() {
    document.body.onclick = () => this.clicked = true
    this.start = new Date().toLocaleString("pt-BR")

    this.isDevStation = localStorage.getItem("developerStation")

    if (
      window.location.href.indexOf("localhost") === -1 &&
      !this.isDevStation
    ) {
      window.onbeforeunload = e => this.sendStats(e)

      window.onblur = e => this.sendStats(e)

      fetch("https://ipapi.co/json/")
        .then(res => res.json())
        .then(json => (this.json = json))
    } else if (this.isDevStation) {
      airtable.sendRequestInfo({ devStation: true })
    }
  },
  mounted() {
    this.checkLanguage()
    if (this.$refs.prabhupadaChanting) {
      this.$refs.prabhupadaChanting.volume = .005
      this.attachListener()
    } else {
      let counter = 0,
        retryInterval = setInterval(() => {
          if (this.$refs.prabhupadaChanting) {
            this.$refs.prabhupadaChanting.volume = .005
            this.attachListener()
            clearInterval(retryInterval)
            return
          }
          counter++
        }, 5000)
    }

    window.onresize = () => {
      this.windowWidth = window.innerWidth
    }

    document.querySelector("#inspire > div > main").onclick = () => {
      if (this.mini === false) this.mini = true
    }

    document.onclick = e => {
      // 
      if (
        e.srcElement.className !== "v-navigation-drawer__content" &&
        e.srcElement.className !== "v-icon notranslate mdi mdi-menu theme--dark" &&
        this.mini === false
      ) {
        setTimeout(() => {
          // this.mini = true
          if (this.windowWidth < 371)
            setTimeout(() => {
              this.drawer = false
            }, 350)
        }, 250)
      }
    }

    window.location.href.indexOf("localhost") > -1
      ? this.items.push({ title: "shop", icon: "shop", componentName: "Shop" }) 
      : null

    // this.speechRecognizer = new webkitSpeechRecognition()
    // this.speechRecognizer.continuous = true
    // this.speechRecognizer.interimResults = true
    // this.speechRecognizer.lang = this.language === 'pt' ? 'pt-BR' : 'en-US'

    // this.speechRecognizer.onresult = function (event) {
    //   console.log('speechRecognizer.onresult', event)
    // }

    // this.speechRecognizer.onspeechstart = e => {
    //   console.log('onspeechstart', e)
    // }

    // this.speechRecognizer.onend = () => {
    // this.speechR ecognizer.start();
    // }

    // todo, to-finish -> speechRecognizer
    // this.speechRecognizer.start()
  },
  watch: {
    clicked(nv) {
      if (nv) {
        // this.playBackground()
      }
    }
  },
  computed: {
    ...mapGetters(['volume'])
    /* language() {
         if (this.lang) {
           return this.lang
         } else {
           this.checkLanguage()
         }
         return this.lang */
  },
  data() {
    const isSmallScreen = window.innerWidth < 500
    return {
      isMobile:
        /Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        ),
      clicked: false,
      socialSharingTitle: this.language === "pt" ? 'Krishna Disse' : 'Krishna Said',
      socialSharingDescription: this.language === "pt" ? 'Esse site mostra informações sobre filosofia espiritual Vaishnava' : 'This website brings knowledge about Vaishnava philosophy',
      socialSharingQuote: this.language === "pt" ? 'Cante Hare Krishna' : 'Chant Hare Krishna',
      fixed: true,
      windowWidth: window.innerWidth,
      mini: isSmallScreen ? false : true,
      drawer: isSmallScreen ? false : true,
      items: [
        { title: "show-me-krishna", icon: "send", componentName: "Home" },
        { title: "go-to-about", icon: "move_to_inbox", componentName: "About" },
        { title: "go-to-shiva", icon: "3d_rotation", componentName: "Shiva" },
        { title: "go-to-ganesh", icon: "album", componentName: "LordGanesh" },
        { title: "go-to-kali", icon: "female", componentName: "KaliDevi" },
        
        {
          title: "leave-your-comment",
          icon: "card_travel",
          componentName: "Comments"
        },
        { title: "faq", icon: "dashboard", componentName: "Faqs" },
        {
          title: "srimad-bhagavatam",
          icon: "change_history",
          componentName: "SrimadBhagavatam"
        },
        { title: "ramayana", icon: "today", componentName: "Ramayana" },
        {
          title: "bhagavad-gita-40-verses",
          icon: "forum",
          componentName: "BhagavadG40"
        },
        { title: "blog", icon: "archive", componentName: "Blog" },
        { title: "admin", icon: "flag", componentName: "Admin" }
      ],
      lang: null,
      speechRecognizer: null,
      availableCommands: [
        "play",
        "stop",
        "next",
        "previous",
        "toque",
        "pare",
        "próximo",
        "anterior"
      ],
      menuVisible: false,
      json: null,
      start: null,
      end: null,
      alreadySent: false,
      isDevStation: null,
      showVolumeSlider: false,
    }
  },
  methods: {
    ...mapActions(['setVolume']),
    checkRoute() {
      if (this.$route.name == 'Home' && this.isMobile) {
        return false
      }
      return true
    },
    playBackground() {
      // this.$refs.prabhupadaChanting.play()
    },
    attachListener() {
      // this.$refs.prabhupadaChanting.oncanplay = () => {
      //   if (this.clicked) {
      //     this.playBackground()
      //   }
      // }
    },

    toggleDisable() {
      return this.windowWidth > 470 ? false : true
    },

    showQuiz() {
      console.log('show quiz')
    },

    // closeLateralBar() {

    //
    // this.mini = true

    // setTimeout(() => {
    //     this.drawer = false
    //   }, 200)
    // },

    openLateralBar() {
      // 
      if (this.windowWidth < 371) {
        // this.drawer = !this.drawer
        // setTimeout(() => {
          this.mini = false
        // }, 200)
      } 
      else {
        this.mini = !this.mini
      }
      this.drawer = !this.drawer
    },

    sendStats(e) {
      if (!this.alreadySent) {
        e.returnValue = "o/"
        this.end = new Date().toLocaleString("pt-BR")
        !this.json ? (this.json = {}) : null
        this.json.timeSpentInfo = {
          start: this.start,
          end: this.end,
          typeOfEvent: e.type
        }
        airtable.sendRequestInfo(this.json)
        this.alreadySent = true
      }
    },

    checkIfDevMode() {
      // return
      // return "audio/SP_Bhajans_05_-_Prayers,_Kirtan.mp3"
      location.href.indexOf("localhost") === -1 &&
      !localStorage.getItem("developerStation")
        ? "audio/SP_Bhajans_05_-_Prayers,_Kirtan.mp3"
        : null
    },

    setLang() {
      this.lang == "en"
        ? ((this.lang = "pt"), sessionStorage.setItem("lan", "pt"))
        : ((this.lang = "en"), sessionStorage.setItem("lan", "en"))
      eventBus.$emit("updateLanguage", this.lang)

      setTimeout(() => {
        const iframe = document.querySelector("iframe")
        if (iframe) {
          if (this.lang === "en") {
            let switchLocale = iframe.src.replace(
              "locale=pt_BR",
              "locale=en_US"
            )
            document.querySelector("iframe").src = switchLocale
          } else {
            let switchLocale = iframe.src.replace(
              "locale=en_US",
              "locale=pt_BR"
            )
            document.querySelector("iframe").src = switchLocale
          }
        }
      }, 2000)
    },

    translate(section, tooltip) {
      switch (section) {
        case "show-quiz":
          if (this.language === "pt") return "Mostre o quiz?"
          else return "Show the quiz?"
        case "who-is-krishna":
          if (this.language === "pt") return "Quem é Krishna?"
          else return "Who is Krishna?"

        case "click-to-translate":
          if (this.language === "pt") return "Click to translate"
          else return "Clique para traduzir"

        case "go-to-about":
          if (this.language === "pt") return "Info sobre o projeto"
          else return "Info about this project"

        case "show-me-krishna":
          if (this.language === "pt") return "Me mostre Krishna"
          else return "Show me Krishna"

        case "go-to-shiva":
          if (this.language === "pt") return "Senhor Shiva"
          else return "Lord Shiva"

        case "go-to-ganesh":
          if (this.language === "pt") return "Senhor Ganesh"
          else return "Lord Ganesh"

        case "go-to-kali":
          if (this.language === "pt") return "Deusa Kali"
          else return "Goddess Kali"

        case "go-to-adresses":
          if (this.language === "pt") return "Endereços templos"
          else return "Temple adresses"

        case "leave-your-comment":
          if (this.language === "pt") return "Deixe seu comentário"
          else return "Leave your comment"

        case "faq":
          if (this.language === "pt") return "Perguntas frequentes"
          else return "Frequent questions"

        case "krishna-said":
          if (this.language === "pt") return "Krishna disse"
          else return "Krishna said"

        case "shop":
          if (this.language === "pt") return "Loja"
          else return "Shop"

        case "site-description":
          if (this.language === "pt")
            return "Esse site foi criado com intuito de promover a propagação do Movimento do Canto Congregacional dos Cantos dos Nomes de Krishna (Deus) iniciado por Sri Caitanya Mahaprabhu há 500 anos"
          else
            return "This website was created in order to promote the spread of the Movement of the congregational chanting of the Names of Krishna (God) started by Sri Caitanya Mahaprabhu 500 years ago"

        case "golokera-prema-dhan":
          if (this.language === "pt")
            return "Golokera Prema Dhan - Harinam Sankirtan - O Néctar do Cantar dos Nomes de Deus"
          else
            return "Golokera Prema Dhan - Harinam Sankirtan - The Nectar of Chanting the Holy Names of God"

        case "share-on-social-media":
          if (this.language === "pt") return "Compartilhe"
          else return "Share"

        case "srimad-bhagavatam":
          return "Srimad-Bhagavatam"

        case "admin":
          return "Admin"

        case "ramayana":
          if (!tooltip) return "Ramayana"
          else if (this.language === "pt")
            return "A história do Senhor Ramacandra"
          else return "The story of Lord Ramacandra"

        case "bhagavad-gita-40-verses":
          if (!tooltip) return "Bhagavad-gita"
          else if (this.language === "pt") return "40 versos mais importantes"
          else return "40 most important verses"

        case "blog":
          if (this.language === "pt") return "Postagens"
          else return "News Feed"

        default:
          break
      }
    }
  }
}
</script>

<style>
/* #app,
  .md-app {
    min-height: 100vh;
  } */

#btn-change-language {
  padding: 0;
  width: 80px;
}

/* .md-title {
    width: 70%;
  } */

.btn:hover {
  cursor: pointer;
}

/* .md-toolbar,
  .md-toolbar-row {
    top: -59px;
  } */

.social-media-icon {
  margin: 0 16px 0 0px;
}

.social-media-icon > i {
  font-size: 25px;
}

.social-media-icon:hover {
  cursor: pointer;
}

#footer {
  margin: 2% 0 2% 8%;
}

.v-list-item > a {
  width: 100%;
  display: flex;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

@media screen and (max-width: 755px) {
  #footer {
    margin-left: 10%;
  }
}

@media screen and (max-width: 600px) {
  #footer {
    margin-left: 14%;
  }
}

@media screen and (max-width: 505px) {
  #footer {
    margin-left: 20%;
  }

  #click-to-translate__span {
    margin: 0 0 0 15%;
  }
}

@media screen and (max-width: 370px) {
  #footer {
    margin-left: 2%;
  }
}

.v-content {
  min-height: 700px;
}

.v-slider--vertical .v-slider__track-container {
  width: 8px !important;
}
</style>